/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EquipmentMapList } from './EquipmentMapList';
import {
    EquipmentMapListFromJSON,
    EquipmentMapListFromJSONTyped,
    EquipmentMapListToJSON,
    EquipmentMapListToJSONTyped,
} from './EquipmentMapList';

/**
 * 
 * @export
 * @interface PaginatedEquipmentMapListList
 */
export interface PaginatedEquipmentMapListList {
    /**
     * 
     * @type {string}
     * @memberof PaginatedEquipmentMapListList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedEquipmentMapListList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<EquipmentMapList>}
     * @memberof PaginatedEquipmentMapListList
     */
    results: Array<EquipmentMapList>;
}

/**
 * Check if a given object implements the PaginatedEquipmentMapListList interface.
 */
export function instanceOfPaginatedEquipmentMapListList(value: object): value is PaginatedEquipmentMapListList {
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedEquipmentMapListListFromJSON(json: any): PaginatedEquipmentMapListList {
    return PaginatedEquipmentMapListListFromJSONTyped(json, false);
}

export function PaginatedEquipmentMapListListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedEquipmentMapListList {
    if (json == null) {
        return json;
    }
    return {
        
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(EquipmentMapListFromJSON)),
    };
}

export function PaginatedEquipmentMapListListToJSON(json: any): PaginatedEquipmentMapListList {
    return PaginatedEquipmentMapListListToJSONTyped(json, false);
}

export function PaginatedEquipmentMapListListToJSONTyped(value?: PaginatedEquipmentMapListList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(EquipmentMapListToJSON)),
    };
}

